export const routeTitles = {
  '/': 'Landing Page',
  '/gallery': 'Gallery',
  '/teacher/dashboard': 'Teacher Dashboard',
  '/admin/dashboard': 'Admin Dashboard',
  '/teacheronboardsuccess': 'Teacher Onboard Success',
  '/drawboard': 'Draw Board',
  '/teacherrefer/:id': 'Draw Board',
  '/admin/download': 'Download Page',
  '/auth/admin/signin': 'Admin Sign In',
  '/auth/teacher/signin': 'Teacher Sign In',
  '/auth/teacher/signup': 'Teacher Sign Up',
  '/auth/admin/forgotpassword': 'Admin Forgot Password',
  '/auth/teacher/forgotpassword': 'Teacher Forgot Password',
  '/my-codes' : 'My Codes',
  '/profile' : 'Profile',
  '/change-password' : 'Change Password',
  '/help' : 'Help',
};

export const matchRouteTitle = (pathname, routeMap) => {
  const pathSegments = pathname.split('/').filter(Boolean);

  for (const pattern in routeMap) {
    const patternSegments = pattern.split('/').filter(Boolean);
    if (patternSegments.length !== pathSegments.length) continue;

    const isMatch = patternSegments.every((seg, i) => {
      return seg.startsWith(':') || seg === pathSegments[i];
    });

    if (isMatch) return routeMap[pattern];
  }

  return 'Unknown Page';
};
